import { render } from "./AccountsClosed.vue?vue&type=template&id=fc21f296&scoped=true"
import script from "./AccountsClosed.vue?vue&type=script&lang=js"
export * from "./AccountsClosed.vue?vue&type=script&lang=js"

import "./AccountsClosed.vue?vue&type=style&index=0&id=fc21f296&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc21f296"]])

export default __exports__